module.exports = __webpack_public_path__ + "static/img/image-box1.c23336b7.jpg";